// extracted by mini-css-extract-plugin
var _1 = "PostBreadcrumbs-module__animateUploadProgressBarWidth--PltZG";
var _2 = "PostBreadcrumbs-module__animatedBackground--DVayM";
var _3 = "PostBreadcrumbs-module__container--WXQ8L";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container" }
